$(document).ready(function () {

  function togglePlans() {
    var typeSelect = $('.js-dc-pricing-select');
    var typeParent = $('.js-dc-pricing-parent');
    var promoTitle = $(".js-dc-promo-superpower-title");
    var promoClass = 'dc-promo-superpower';
    var promoStatusClass = 'js-dc-promo-superpower';
    var leftClass = 'dc-pricing-type--left';
    var focusClass = 'dc-pricing-type--focus';
    var rightClass = 'dc-pricing-type--right';

    if (typeSelect) {
      typeSelect.on('change', function () {

        if (typeParent.hasClass(promoStatusClass)) {

          typeParent.removeClass(function (index, className) {
            return (className.match(/(^|\s)dc-pricing-type-\S+/g) || []).join(' ');
          });

          if (this.value === 'left') {
            typeParent.addClass(leftClass).removeClass(promoClass);
            promoTitle.html("Plans & Pricing");
          }

          if (this.value === 'focus') {
            typeParent.addClass(focusClass).addClass(promoClass);
            promoTitle.html("Make Data Science Your Superpower");
          }

          if (this.value === 'right') {
            typeParent.addClass(rightClass).removeClass(promoClass);
            promoTitle.html("Plans & Pricing");
          }
        } else {

          typeParent.removeClass(function (index, className) {
            return (className.match(/(^|\s)dc-pricing-type-\S+/g) || []).join(' ');
          });

          if (this.value === 'left') {
            typeParent.addClass(leftClass);
          }

          if (this.value === 'focus') {
            typeParent.addClass(focusClass);
          }

          if (this.value === 'right') {
            typeParent.addClass(rightClass);
          }
        }

      });
    }
  }

  function toggleCurrencies() {
    var $currencySelect = $('.js-dc-currency-select')
    if ($currencySelect.length > 0) {
      $currencySelect.on('change', function (event) {
        var $select = $(event.currentTarget);
        var currencyCode = $select.val();
        var $newCurrencySymbol = $('.js-dc-currency[data-code="' + currencyCode + '"]');
        if ($newCurrencySymbol.length > 0) {
          Cookies.set('dc_pricing_currency', currencyCode);
          $('.js-dc-currency').hide();
          $newCurrencySymbol.show();
          $currencySelect.val(currencyCode);
          $('.js-dc-currency-select--mobile').prop("selectedIndex", 0);
        }
        if (['inr', 'jpy'].includes(currencyCode)) {
          // Number is to large
          $('.js-dc-pricing').addClass('dc-pricing--long');
        } else {
          $('.js-dc-pricing').removeClass('dc-pricing--long');
        }
      });
      var cookieCurrency = Cookies.get('dc_pricing_currency');
      if (cookieCurrency) {
        $currencySelect.val(cookieCurrency);
        $currencySelect.first().trigger('change');
      }
    }
  }

  function toggleYearlyPayment() {
    var yearlyCheckbox = $(".js-dc-pay-yearly-checkbox");
    var promoParent = $(".js-dc-pricing-parent");
    var promoTitle = $(".js-dc-promo-superpower-title");
    var promoStatusClass = 'js-dc-promo-superpower';

    yearlyCheckbox.change(function () {

      $yearly = $('.js-dc-pay-yearly');
      $monthly = $('.js-dc-pay-monthly');
      if ($yearly.length > 0 && $monthly.length > 0) {
        if (this.checked) {
          $monthly.hide();
          $yearly.show();
          yearlyCheckbox.prop("checked", true);
          if (promoParent.hasClass(promoStatusClass)) {
            promoParent.addClass("dc-promo-superpower");
            promoTitle.html("Make Data Science Your Superpower");
          }
        } else {
          $yearly.hide();
          $monthly.show();
          yearlyCheckbox.prop("checked", false);
          if (promoParent.hasClass(promoStatusClass)) {
            promoParent.removeClass("dc-promo-superpower");
            promoTitle.html("Plans & Pricing");
          }
        }
      }
    });

    if (promoParent.hasClass(promoStatusClass)) {
      $(".js-dc-savings-sentence").click(function () {
        yearlyCheckbox.prop('checked', true);
        $yearly = $('.js-dc-pay-yearly');
        $monthly = $('.js-dc-pay-monthly');
        if ($yearly.length > 0 && $monthly.length > 0) {
          $monthly.hide();
          $yearly.show();
          promoParent.addClass("dc-promo-superpower");
          promoTitle.html("Make Data Science Your Superpower");
        }
      });
    }
  }

  // This should be moved if the carousel is used elsewhere
  function hoverCarousel() {
    var triggerElements = '.js-click-carousel-trigger';
    var targetElements = '.js-click-carousel-target';
    var targetSelect = '.js-click-carousel-select';
    var activeClass = 'dc-is-active'

    $(triggerElements).on('mouseenter', function () {
      var targetNumber = $(this).data('click-target');

      $(triggerElements).removeClass(activeClass);
      $(targetElements).removeClass(activeClass);
      $(targetSelect).val(targetNumber);
      $('[data-click-target="' + targetNumber + '"]').addClass(activeClass);
    });

    $(targetSelect).on('change', function () {
      var targetNumber = $(this).val();

      $(triggerElements).removeClass(activeClass);
      $(targetElements).removeClass(activeClass);
      $('[data-click-target="' + targetNumber + '"]').addClass(activeClass);
    });
  }

  togglePlans();
  toggleCurrencies();
  toggleYearlyPayment();
  hoverCarousel();

});
